import type { FilterDataType } from '../types/types';
import { ApplicationTabId } from './application-tabs.constants';

export const STATUS_DATA = [
  {
    id: 'invitation-sent',
    label: 'Invite sent',
    labelId: 'invitation-sent',
  },
  {
    id: 'renewal-created',
    label: 'Renewal decision needed',
    labelId: 'confirm-lease-renewal',
  },
  {
    id: 'lease-details',
    label: 'Lease details needed',
    labelId: 'provide-lease-details',
  },
  {
    id: 'in-progress',
    label: 'In progress',
    labelId: 'application-in-progress',
  },
  {
    id: 'pending-approval-decision',
    label: 'In review',
    labelId: 'pending-approval-decision',
  },
  {
    id: 'pending-payment-signature',
    label: 'Pending payment/signature',
    labelId: 'pending-payment-signature',
  },
  {
    id: 'bond-issued',
    label: 'Bond issued',
    labelId: 'deal-closed',
  },
  {
    id: 'denied',
    label: 'Denied',
    labelId: 'application-denied',
  },
  {
    id: 'closed',
    label: 'Canceled',
    labelId: 'canceled-not-using-theguarantors',
  },
] as const satisfies readonly FilterDataType[];

type StatusId = (typeof STATUS_DATA)[number]['id'];

const ALL_STATUS_IDS: StatusId[] = STATUS_DATA.map((status) => status.id);

/** Every status except the excluded ones, in STATUS_DATA order. */
const statusIdsExcept = (...excluded: StatusId[]): StatusId[] =>
  ALL_STATUS_IDS.filter((id) => !excluded.includes(id));

const DEFAULT_STATUS_FILTERS = {
  drawer: ALL_STATUS_IDS,
  pills: statusIdsExcept('renewal-created'),
};

const EMPTY_STATUS_FILTERS = {
  drawer: [],
  pills: [],
};

export const STATUS_FILTERS_BY_TAB = {
  [ApplicationTabId.AllApplications]: DEFAULT_STATUS_FILTERS,
  [ApplicationTabId.NewApplications]: DEFAULT_STATUS_FILTERS,
  [ApplicationTabId.ExpiringSoon]: EMPTY_STATUS_FILTERS,
  [ApplicationTabId.RenewalApplications]: {
    drawer: statusIdsExcept('invitation-sent', 'renewal-created', 'lease-details'),
    pills: statusIdsExcept('invitation-sent', 'renewal-created', 'lease-details', 'in-progress'),
  },

  // New tabs
  [ApplicationTabId.AllRecords]: {
    drawer: statusIdsExcept('renewal-created'),
    pills: [],
  },
  [ApplicationTabId.LeaseDetailsNeeded]: EMPTY_STATUS_FILTERS,
  [ApplicationTabId.RenewalDecisionNeeded]: EMPTY_STATUS_FILTERS,
  [ApplicationTabId.IssuedBonds]: EMPTY_STATUS_FILTERS,
} satisfies Record<
  ApplicationTabId,
  {
    drawer: StatusId[];
    pills: StatusId[];
  }
>;
